module.exports = __webpack_public_path__ + "media/images/ccs-3a58ab11a329cc8e8c2060d140d48fa2edc27a6d9561e3b18acc52a63c84cd5e.png";